import { useEffect } from "react";

import { initializeDigitalData } from "@/src/utils/digitalData/initializeDigitalData";

export const useDigitalDataInit = (locale: string) => {
  useEffect(() => {
    if (!globalThis.digitalData) {
      globalThis.digitalData = initializeDigitalData(locale);
      // Prevent extensions to block adding new properties while allowing deletion/modification
      try {
        Object.preventExtensions(globalThis.digitalData);
      } catch (error: unknown) {
        // If preventExtensions fails, continue without it
        const message = error instanceof Error ? error.message : String(error);
        console.warn(
          "[DDL] Failed to prevent extensions on digitalData object:",
          message
        );
      }
    }
  }, [locale]);
};
